import React from 'react'
import './styles/PageSection.css'

export default function PageSection(props) {

  const { subtitle, title, text, btn, img,
    direction='', className='' } = props

  return (
    <div className={`page-section ${direction} ${className}`}>
      <div className="img-container">
        <img
          src={img}
          alt={subtitle || title}
        />
      </div>
      <div className="text-container">
        <div className="text-content">
          {subtitle && <h6>{subtitle}</h6>}
          {title && <h2>{title}</h2>}
          {text}
          {btn}
        </div>
      </div>
    </div>
  )
}
